// components/screens/PaymentSuccessScreen.tsx
import { NativeStackNavigationProp } from '@react-navigation/native-stack';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import PaymentResultPage from '../Components/PaymentResult/PaymentResultPage';
import { RootStackParamList } from '../navigator';

interface Props {
	navigation: NativeStackNavigationProp<RootStackParamList, 'PaymentSuccess'>;
}

export default function PaymentSuccessScreen({ navigation }: Props) {
	const { t } = useTranslation();

	useEffect(() => {
		const timer = setTimeout(() => {
			navigation.replace('Profile');
		}, 3000);

		return () => clearTimeout(timer);
	}, [navigation]);

	return (
		<PaymentResultPage
			status='success'
			title={t('T_SITE_PAYMENT_SUCCESS', { defaultValue: 'Payment Successful!' })}
			message={t('T_SITE_PAYMENT_REDIRECTING', { defaultValue: 'Redirecting to your profile...' })}
		/>
	);
}
